import { Button, Modal } from "antd";
import React, { useContext, useState } from "react";
import { EditSessionModalContext } from "./types";
import { DeleteOutlined } from "@ant-design/icons";
import { TimeTrackingUserDataContext } from "../../../../TimeTrackingUserDataProvider";
interface Props {
  sessionId: string;
  onClose: () => void;
}
const ModalFooter: React.FC<Props> = ({ sessionId, onClose }) => {
  const [isDeleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const { onSubmit, saving } = useContext(EditSessionModalContext);
  const { deleteSession } = useContext(TimeTrackingUserDataContext);
  const handleDeleteEvent = async (id: any) => {
    deleteSession(id);
    setDeleteConfirmVisible(false);
    onClose();
  };

  const showDeleteConfirmation = () => {
    setDeleteConfirmVisible(true);
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 4,
        }}
      >
        <Button
          onClick={showDeleteConfirmation}
          type="text"
          danger
          icon={<DeleteOutlined style={{ fontSize: 18 }} />}
          style={{ padding: "4px 10px", height: 36, width: 36 }}
        />
        <div style={{ flex: 1 }} />
        <Button
          onClick={onClose}
          style={{
            marginRight: 8,
            borderRadius: 6,
            height: 32,
            fontSize: 14,
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit()}
          type="primary"
          loading={saving}
          style={{
            borderRadius: 6,
            height: 32,
            fontSize: 14,
            backgroundColor: "#137AE9",
            borderColor: "#137AE9",
          }}
        >
          Save
        </Button>
      </div>
      <Modal
        title="Confirm Deletion"
        visible={isDeleteConfirmVisible}
        onOk={() => handleDeleteEvent(sessionId)}
        onCancel={() => setDeleteConfirmVisible(false)}
        okText="Delete"
        okType="danger"
        cancelButtonProps={{ style: { marginRight: "10px" } }}
        okButtonProps={{
          style: { background: "red", borderColor: "red", color: "white" },
        }}
        centered
      >
        <p style={{ fontSize: "16px", color: "#9e9e9e" }}>
          Are you sure you want to delete this session? This action cannot be
          undone.
        </p>
      </Modal>
    </>
  );
};
export default ModalFooter;
